class BettergutReasons extends HTMLElement {
  connectedCallback() {
    var carousel = this.querySelector(".bgr__swiper");
    if (!carousel) return;

    var dotsEl = this.querySelector(".bgr__dots");
    var dotsId = dotsEl ? "#" + dotsEl.id : null;

    Object.assign(carousel, {
      roundedLengths: true,
      pagination: dotsId ? { clickable: true, el: dotsId } : false,
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 12,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });

    carousel.initialize();
  }
}

if (!customElements.get("bettergut-reasons")) {
  customElements.define("bettergut-reasons", BettergutReasons);
}
